import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  GroupTitle,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Tabs,
  Upload
} from "antd";
import { HaberForm } from "../../styledElements";
import { StyledTab } from "../../pageStyled";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../pageStyled";
import moment from "moment";
import OrderDetailsData from "./orderDetails";
import { useLocation, useNavigate } from "react-router";
import {
  getPosDetails,
  editPo,
  bulkChangeOrderState,
  getAllOrdersList,
  getAllOrdersListByPono,
} from "../../../Services/orderServices";
import { getCustomers } from "../../../Services/customerServices";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import warning from "../../../Assets/Icons/warning.png";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import { ModalPopup } from "../../../Components/Modal/modal";
import { Country, State } from "country-state-city";
import { poExists } from "../../../Services/orderServices";
import { capital_letter, toHandlePOName } from "../../../Utils/helper/helper";
import { uploadPODocuments, deletePODocuments, newUploadOrders, newDeleteOrders } from "../../../Services/uploadServices";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import { getImageURL } from "../../../Services/deckleMatchServices";

const { Option } = Select;
const { Dragger } = Upload;
const PoDetailsData = (props) => {
  const [cities, setCities] = useState([]);
  const [billingCities,setBillingCities] = useState([]);
  const [shippingCities,setShippingCities] = useState([]);
  const [checkedBox, setCheckedBox] = useState(false);
  const location = useLocation();
  const [poNumber, setPoNumber] = useState(location.state.poNumber);
  const [backKey, setBackKey] = useState(location.state?.backKey);
  // const roles = location.state.roles;
  const [poDetails, setPoDetails] = useState();
  const [editMode, setEditMode] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [poDate, setDate] = useState(moment().format("DD/MM/YYYY"));
  const [customer, setCustomer] = useState();
  const [customerList, setCustomerList] = useState([]);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [isOrderDetails, setIsOrderDetails] = useState(false);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [errorMsg , setErrorMsg] = useState();

  const [isCustomerDropdownOpen, setCustomerDropdown] = useState(false);
  const [isConsigneeDropdownOpen, setConsigneeDropdown] = useState(false);
  const [isCountryDropdownOpen, setCountryDropdown] = useState(false);
  const [isStateDropdownOpen, setStateDropdown] = useState(false);
  const [isShippingCountryDropdownOpen, setShippingCountryDropdown] = useState(false);
  const [isShippingStateDropdownOpen, setShippingStateDropdown] = useState(false);
  const [shippedCustAddCheckbox, setshippedCustAddCheckbox] = useState(false);
  const [shippedConsigneeAddCheckbox, setShippedConsigneeAddCheckedBox] = useState(false);
  const [billingCustAddCheckbox, setBillingCustAddCheckbox] = useState(false);
  const [billingConsigneeAddCheckbox, setBillingConsigneeAddCheckedBox] = useState(false);
  const [isBillingCountryDropdownOpen, setBillingCountryDropdown] = useState(false);
  const [isBillingStateDropdownOpen, setBillingStateDropdown] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [newOrderDrawer, setNewOrderDrawer] = useState(false);
  const [rendering, setRendering] = useState(true);
  const [poData, setPoData] = useState();
  const [deliConsgineeCheckedBox, setConsigneeDeliAddCheckedBox] = useState(false);
  const [isVisibleCancelModal, setIsVisibleCancelModal] = useState(false);
  const [consignee, setConsignee] = useState("");
  const [po, setPo] = useState();
  const history = useNavigate();
  const poFromOrders = useLocation();
  const [uploadedFile, setUploadedFile] = useState([]);
  const [uploadedFileErr, setFileErr] = useState([]);
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [viewUploadedFiles, setViewUploadedFiles] = useState([]);
  const [deletedFile, setDeletedFile] = useState([]);
  const [orderManagementSettings, setOrderManagementSettings] = useState();
  const [deckleManagementSettings, setDeckleManagementSettings] = useState({});
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [switchFetchOrdersfromERP,setSwitchFetchOrdersfromERP] = useState(false);
  
  useEffect(()=>{
    (async()=>{
      const orderManagementSettings = await getWorkflowSettings("order_management");
      setSwitchFetchOrdersfromERP(orderManagementSettings?.data?.fetch_orders_from_erp?.value);
    })();
  },[])

  const fileUploadData = {
    name: 'file',
    multiple: false,
    maxCount: 5,
    listType: 'picture',
    accept: 'image/jpg, image/jpeg, .pdf',
    defaultFileList: [...uploadedFile],
    beforeUpload: () => {
      return false
    },
    async onChange(info) {
      const { status } = info.file;
      if (status === 'removed'){
        let uploadedFileArr = [...uploadedFile];
        let removedFile = uploadedFileArr.filter((d) => d.uid !== info.file.uid);
        if(info.file?.["oldFile"]){
          setUploadedFile((prevState) => prevState.filter((d) => d.id !== info.file.id));
        } else{
          setUploadedFile((prevState) => prevState.filter((d) => d.uid !== info.file.uid));
        }
        if(!removedFile?.length){
          setFileErr([]);
        } else{
          let prevErr = [...uploadedFileErr];
          let errArr = [];
          if(prevErr?.length){
            prevErr.map((ele) => {
              if(ele.key !== info.file.uid){
                errArr.push(ele);
              }
            });            
            setFileErr(errArr);
          } else{
            setFileErr([]);
          }
        }

        if(info.file?.["oldFile"]){
          let deletedArr = uploadedFile.filter((ele) => (ele?.["oldFile"] && (ele?.["id"] == info.file.id)));
          setDeletedFile(deletedArr);
          // for(let i = 0; i < uploadedFile?.length; i++){
          //   if(uploadedFile[i]?.["oldFile"] && (uploadedFile[i]["id"] == info.file.id)){
          //     // await deletePODocuments(poDetails?.number, uploadedFile[i]).then((response) => {
          //     //   console.log(response);
          //     // }).catch((err) => {
          //     //   console.log(err);
          //     // });
          //   }     
          // }
        }
      } else{
        let arr = [];
        info.fileList.map((item) => {
          if(item?.originFileObj){
            arr.push(item["originFileObj"]);
          } else{
            arr.push(item);
          }
        });
        setUploadedFile(arr);
        let fileSize = (info.file.size / 1024 / 1024)?.toFixed(2);
        let errArr = [];
        let prevErr = [...uploadedFileErr];
        if((fileSize > 1) || (info.file.type != "application/pdf" && info.file.type != "image/jpeg" && info.file.type != "image/jpg")){
          let errObj = {};
          errArr.push(...prevErr);
          errObj["key"] = info.file.uid;
          errObj["err"] = true;
          errObj["name"] = info.file.name;
          errArr.push(errObj);
          setFileErr(errArr);
        } else{
          errArr.push(...prevErr);
          setFileErr(errArr);
        }
      }
    },
    onDrop(e) {
      // console.log('Dropped files', e.dataTransfer.files);
      setUploadedFile((prevState) => prevState.filter((d) => d.uid !== e.dataTransfer.files.uid));
    },  
  };

  // const setCustomerAddress = () => {
  //   const fields = form.getFieldsValue();
  //   const currentCustomerDetails = customerList.filter((cust) => {
  //     return cust.code === customer;
  //   });

  //   let newObj = {
  //     ...fields,
  //     delivery_address_line_1:
  //       currentCustomerDetails[0].delivery_address_line_1,
  //     delivery_address_line_2:
  //       currentCustomerDetails[0].delivery_address_line_2,
  //     country: currentCustomerDetails[0].country,
  //     City: currentCustomerDetails[0].city,
  //     state: currentCustomerDetails[0].state,
  //     pincode: currentCustomerDetails[0].pincode,
  //   };
  //   form.setFieldsValue(newObj);
  // };

  // const onChangeHandlerBox = (e) => {
  //   if (e.target.checked) setCustomerAddress();
  //   setCheckedBox(e.target.checked);
  // };
  const handleProvinceChange = (value) => {
    setCities(State.getStatesOfCountry(value));
    form.setFieldsValue({state: State.getStatesOfCountry(value)[0]?.name})
  };

  const saveHandler = () => {
    form.submit();
  };

  // const approvalHandler = () => {
  //   modalShow();
  // };

  const handleCancel = () => {
    //form.resetFields();
    setIsVisibleCancelModal(true);
  };

  // const dateHandler = (e) => {
  //   setDate(e._i);
  // };

  // const customerHandler = (e) => {
  //   setCustomer(e);
  // };

  const routeChange = () =>{
    setIsOrderDetails(true)
    form.submit()
  }

  const OntoggleSelect =()=>{
    setCustomerDropdown((prevState) => !prevState
  )
  }

  const onToggleSelectForConsginee = () => {
    setConsigneeDropdown((prevState) => !prevState
  )
  }
  
  const routeBack = () => {
    setEditMode(false);
  };

  const clearAddControls = () => {
    form.setFieldsValue({delivery_address_line_1:""});
    form.setFieldsValue({delivery_address_line_2:""});
    form.setFieldsValue({country:""});
    form.setFieldsValue({state:""});
    form.setFieldsValue({City:""});
    form.setFieldsValue({pincode:""});
  }

  //Cancel Changes modal
  const modalCancelShow = () => {
    setIsVisibleCancelModal(true);
  };
  const modalCancelClose = () => {
    setIsVisibleCancelModal(false);
  };
  const modalCancelConfirm = () => {
    routeBack();
    setIsVisibleCancelModal(false);
    form.resetFields();
  };

  const onChangeHandlerBox = (e) => {
    setCheckedBox(e.target.checked);
    if (e.target.checked){
      setConsigneeDeliAddCheckedBox(false);
      setCustomerAddress(customer, "delivery");
    } else{
      clearAddControls();
    }
};

  const deliveryAddConsigneeHandler = (e) => {
    setConsigneeDeliAddCheckedBox(e.target.checked);
    if(e.target.checked){
      setCheckedBox(false);
      setCustomerAddress(consignee, "delivery");
    } else{
      clearAddControls();
    }
  }

  // const handleProvinceChange = (value) => {
  //   setCities(State.getStatesOfCountry(value));
  //   form.setFieldsValue({ state: State.getStatesOfCountry(value)[0]?.name });
  // };
  const handleProvinceChangeForShipping = (value) => {
    setShippingCities(State.getStatesOfCountry(value));
    form.setFieldsValue({ shipping_state: State.getStatesOfCountry(value)[0]?.name });
  };
  const handleProvinceChangeForBilling = (value) => {
    setBillingCities(State.getStatesOfCountry(value));
    form.setFieldsValue({ billing_state: State.getStatesOfCountry(value)[0]?.name });
  };

  const poHandler = (e) => {
    setPo((e.target.value).toUpperCase());
  };

  const dateHandler = (e) => {
    const testDate = new Date(e._d);
    setDate(moment(testDate).format("DD/MM/YYYY"));
  };

  const customerHandler = (e) => {
    setCustomer(e);
    setBillingCustAddCheckbox(true);
    setBillingConsigneeAddCheckedBox(false);
    setCustomerAddress(e, "billing");
    if(form.getFieldValue('consignee') === '' || form.getFieldValue('consignee') === undefined)
    {
      form.setFieldsValue({consignee : e})
      consigneeHandler(e);
    }
  };

  const consigneeHandler = (e) => {
    setConsignee(e);
    setConsigneeDeliAddCheckedBox(true);
    setCheckedBox(false);
    setShippedConsigneeAddCheckedBox(true);
    setshippedCustAddCheckbox(false);
    setCustomerAddress(e, "delivery");
    setCustomerAddress(e, "shipping");
  };

  // const routeChange = () => {
  //   form.submit();
  // };

  const handleAddNewOrder = () => {
    form.submit();
    // setIsButtonClicked(true);
  };

  const showAddNewOrder = () => {
    setNewOrderDrawer(true);
  };

  const onCloseAddNewOrder = () => {
    setNewOrderDrawer(false);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const setCustomerAddress = (key, addressStatus) => {
    const fields = form.getFieldsValue();
    const currentCustomerDetails = customerList?.filter((cust) => {
        return cust.code === key;
      });
    if(currentCustomerDetails?.length){
      if(addressStatus === "delivery"){
        let newObj = {
          ...fields,
          delivery_address_line_1:
            currentCustomerDetails[0]?.delivery_address_line_1,
          delivery_address_line_2:
            currentCustomerDetails[0]?.delivery_address_line_2,
          country: currentCustomerDetails[0]?.delivery_country,
          City: currentCustomerDetails[0]?.delivery_city,
          state: currentCustomerDetails[0]?.delivery_state,
          pincode: currentCustomerDetails[0]?.delivery_pincode,
        };
        form.setFieldsValue(newObj);
      } else if(addressStatus === "shipping"){
        let newObj = {
          ...fields,
          shipping_address_line_1:
            currentCustomerDetails[0]?.delivery_address_line_1,
          shipping_address_line_2:
            currentCustomerDetails[0]?.delivery_address_line_2,
          shipping_country: currentCustomerDetails[0]?.delivery_country,
          shipping_city: currentCustomerDetails[0]?.delivery_city,
          shipping_state: currentCustomerDetails[0]?.delivery_state,
          shipping_pincode: currentCustomerDetails[0]?.delivery_pincode,
        };
        form.setFieldsValue(newObj);
      } else{
        let newObj = {
          ...fields,
            billing_address_line_1:
            currentCustomerDetails[0]?.address_line_1,
            billing_address_line_2:
            currentCustomerDetails[0]?.address_line_2,
            billing_country: currentCustomerDetails[0]?.country,
            billing_city: currentCustomerDetails[0]?.city,
            billing_state: currentCustomerDetails[0]?.state,
            billing_pincode: currentCustomerDetails[0]?.pincode,
        };
        form.setFieldsValue(newObj);
      }
    }
  };

  // const onFinish = async (values) => {
  //   // Checking the existence of po number entered
  //   await poExists(po)
  //     .then((response) => {
  //       console.log("existed:", po);
  //       setActionToaster({
  //         error: !response.error,
  //         msg: `PO ${po} already exists`,
  //       });
  //       showToaster();
  //     })
  //     .catch((error) => {
  //       values["poNumber"] = values["poNumber"].toUpperCase();
  //       values["City"] = capital_letter(values["City"]);
  //       console.log("not existed:", po);
  //       if(isButtonClicked){
  //         let poValues = {
  //           ...values,
  //           date: poDate,
  //           checkedBox: checkedBox,
  //           deliConsgineeCheckedBox: deliConsgineeCheckedBox,
  //           shippedConsigneeAddCheckbox: shippedConsigneeAddCheckbox,
  //           shippedCustAddCheckbox:shippedCustAddCheckbox,
  //           billingCustAddCheckbox: billingCustAddCheckbox,
  //           billingConsigneeAddCheckbox: billingConsigneeAddCheckbox,
  //         }
  //         setPoData(poValues);
  //         showAddNewOrder();
  //       } else{
  //         history("../order-details", {
  //           state: { values: { ...values, 
  //             date: poDate,
  //             checkedBox: checkedBox,
  //             deliConsgineeCheckedBox: deliConsgineeCheckedBox,
  //             shippedConsigneeAddCheckbox: shippedConsigneeAddCheckbox,
  //             shippedCustAddCheckbox:shippedCustAddCheckbox,
  //             billingCustAddCheckbox: billingCustAddCheckbox,
  //             billingConsigneeAddCheckbox: billingConsigneeAddCheckbox,
  //           }, route: "add-new-po" },
  //         });
  //       }
  //     });
  // };

  const OnCountryToggleSelect =()=>{
    setCountryDropdown((prevState) => !prevState
  )
  };

  const OnStateToggleSelect =()=>{
    setStateDropdown((prevState) => !prevState
  )
  };

  const OnShippingCountryToggleSelect =()=>{
    setShippingCountryDropdown((prevState) => !prevState
  )
  };

  const OnShippingStateToggleSelect =()=>{
    setShippingStateDropdown((prevState) => !prevState
  )
  };

  const clearShippedAddControls = () => {
    form.setFieldsValue({shipping_address_line_1:""});
    form.setFieldsValue({shipping_address_line_2:""});
    form.setFieldsValue({shipping_country:""});
    form.setFieldsValue({shipping_state:""});
    form.setFieldsValue({shipping_city:""});
    form.setFieldsValue({shipping_pincode:""});
  };

  const shippedAddCustHandler = (e) => {
    setshippedCustAddCheckbox(e.target.checked);
    if(e.target.checked){
      setShippedConsigneeAddCheckedBox(false);
      setCustomerAddress(customer, "shipping");
    } else{
      clearShippedAddControls();
    }
  };

  const shippedAddConsigneeHandler = (e) => {
    setShippedConsigneeAddCheckedBox(e.target.checked);
    if(e.target.checked){
      setshippedCustAddCheckbox(false);
      setCustomerAddress(consignee, "shipping");
    } else{
      clearShippedAddControls();
    }
  }

  const OnBillingStateToggleSelect = () => {
    setBillingStateDropdown((prevState) => !prevState)
  };

  const OnBillingCountryToggleSelect =()=>{
    setBillingCountryDropdown((prevState) => !prevState
  )
  };

  const clearBiiledAddControls = () => {
    form.setFieldsValue({billing_address_line_1:""});
    form.setFieldsValue({billing_address_line_2:""});
    form.setFieldsValue({billing_country:""});
    form.setFieldsValue({billing_state:""});
    form.setFieldsValue({billing_city:""});
    form.setFieldsValue({billing_pincode:""});
  }

  const billingAddCustHandler = (e) => {
    setBillingCustAddCheckbox(e.target.checked);
    if(e.target.checked){
      setBillingConsigneeAddCheckedBox(false);
      setCustomerAddress(customer, "billing");
    } else{
      clearBiiledAddControls();
    }
  };

  const billingAddConsigneeHandler = (e) => {
    setBillingConsigneeAddCheckedBox(e.target.checked);
    if(e.target.checked){
      setBillingCustAddCheckbox(false);
      setCustomerAddress(consignee, "billing");
    } else{
      clearBiiledAddControls();
    }
  };

  const onFinish = async (values) => {
    
    // Checking and navigating to order-details page
    if(isOrderDetails){
      navigate('../order-details',
      {
        state:
        { 
          values:
          {...values, poNumber:poDetails.number, date:poDate, customer:values.customer
          },
           route:'po-details',
           backKey: backKey
        }
        })
      setIsOrderDetails(false)
    }
    else{
      //save new uploaded files
      let uplodedDocsArr = [];
      for (let i = 0; i < uploadedFile?.length; i++) {
        uplodedDocsArr.push(
          values?.poNumber?.toUpperCase() + "/" + uploadedFile[i]?.["name"]
        );
        if (!uploadedFile[i]?.["oldFile"]) {
          // await uploadPODocuments(values?.poNumber?.toUpperCase(), uploadedFile[i]).then((response) => {
          // }).catch((err) => {
          //   console.log(err);
          // });
          // Step 1: Generate signed URL for upload
          const res = await getImageURL({
            bucket_key: `${values?.poNumber?.toUpperCase()}/${
              uploadedFile[i]["name"]
            }`,
            operation: "upload",
          });

          // Step 2: Upload file to that signed URL
          const uploadResponse = await newUploadOrders(res, uploadedFile[i]);
        }
      }

      let body = {
        delivery_address_line_1: values.delivery_address_line_1,
        delivery_address_line_2: values.delivery_address_line_2,
        delivery_state: values.state,
        delivery_city: values.City,
        delivery_pincode: values.pincode,
        delivery_country: values.country,
        billing_address_line_1: values.billing_address_line_1,
        billing_address_line_2: values.billing_address_line_2,
        billing_city: values.billing_city,
        billing_country: values.billing_country,
        billing_pincode: values.billing_pincode,
        billing_state: values.billing_state,
        shipping_address_line_1: values.shipping_address_line_1,
        shipping_address_line_2: values.shipping_address_line_2,
        shipping_city: values.shipping_city,
        shipping_country: values.shipping_country,
        shipping_pincode: values.shipping_pincode,
        shipping_state: values.shipping_state,
        address_type: {
          billing_address: billingCustAddCheckbox
            ? "customer"
            : billingConsigneeAddCheckbox
            ? "consignee"
            : "",
          delivery_address: checkedBox
            ? "customer"
            : deliConsgineeCheckedBox
            ? "consignee"
            : "",
          shipping_address: shippedCustAddCheckbox
            ? "customer"
            : shippedConsigneeAddCheckbox
            ? "consignee"
            : "",
        },
        other_documents_location: uplodedDocsArr,
      };

      if (poDetails.po_editable) {
        body["number"] =
          toHandlePOName(values.poNumber.toUpperCase()) +
          "#%#" +
          values.customer;
        body["customer"] = values.customer;
        body["consignee"] = values.consignee;
        body["date"] = values.date
          ? new Date(values.date).getFullYear() +
            "-" +
            (values.date && new Date(values.date).getMonth() + 1 <= 9
              ? "0" + parseInt(new Date(values.date).getMonth() + 1)
              : parseInt(new Date(values.date).getMonth() + 1)) +
            "-" +
            new Date(values.date).getDate()
          : "";
      }

      //save edited PO to database
      const poNo = poDetails.number;

      await editPo(poNo, body)
        .then((response) => {
          let newPOData = { ...poDetails };
          // newPOData.number = values.poNumber.toUpperCase();
          newPOData.number = values.poNumber.toUpperCase()+"#%#"+values.customer;
          newPOData.other_documents_location =
            response.data.other_documents_location;
          setPoDetails({ ...newPOData });
          setEditMode(false);
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, 3000);
        })
        .catch((error) => {
          console.log("Error in editing po details:", error);
          setError(true);
          setTimeout(() => {
            setError(false);
          }, 3000);
        });

      for (let i = 0; i < deletedFile?.length; i++) {
        // await deletePODocuments(poNo, deletedFile[i]).then((response) => {
        // }).catch((err) => {
        //   console.log(err);
        // });

        // Step 1: Generate signed URL for upload
        const res = await getImageURL({
          bucket_key: `${poNo}/${deletedFile[i]["name"]}`,
          operation: "delete",
        });

        // Step 2: Upload file to that signed URL
        const uploadResponse = await newDeleteOrders(res, deletedFile[i]);
      }
    }
  };
useEffect(async () => {
    const orderMangSettings = await getWorkflowSettings("order_management");
    setOrderManagementSettings(orderMangSettings.data);
    const deckleMangSettings = await getWorkflowSettings("deckle_management");
    setDeckleManagementSettings(deckleMangSettings?.data);
  }, []);

  useEffect(() => {
    getCustomers()
      .then((response) => {
        setCustomerList(response);
      })
      .catch((error) => {
        console.log(error);
      });
      
    getPosDetails(poNumber)
      .then((response) => {
        setPoDetails(response.data);
        setDate(response.data.date)
        setCustomer(response.data.customer);
        setConsignee(response.data.consignee);
        if(response.data.address_type.delivery_address == 'customer')
        setCheckedBox(true);
      else if(response.data.address_type.delivery_address == 'consignee')
      setConsigneeDeliAddCheckedBox(true);

      if(response.data.address_type.billing_address == 'customer')
        setBillingCustAddCheckbox(true);
      else if(response.data.address_type.billing_address == 'consignee')
      setBillingConsigneeAddCheckedBox(true);

      if(response.data.address_type.shipping_address == 'customer')
        setshippedCustAddCheckbox(true);
      else if(response.data.address_type.shipping_address == 'consignee')
      setShippedConsigneeAddCheckedBox(true);

      })
      .catch((error) => {
        console.log(error);
      });
    return () => {
      setPoDetails({});
      setCustomerList({});
    };
  }, []);

  useEffect(() => {
  const fetchData = async () => {
    if (poDetails && poDetails.date) {
      setBillingCities(
        State.getStatesOfCountry(
          Country.getAllCountries().find(
            (data) => data.name === poDetails?.billing_country
          )?.isoCode
        )
      );

      setCities(
        State.getStatesOfCountry(
          Country.getAllCountries().find(
            (data) => data.name === poDetails?.delivery_country
          )?.isoCode
        )
      );

      setShippingCities(
        State.getStatesOfCountry(
          Country.getAllCountries().find(
            (data) => data.name === poDetails?.shipping_country
          )?.isoCode
        )
      );

      setDate(poDetails?.date);
      setCustomer(poDetails?.customer);

      // fetch document URLs
      if (poDetails?.other_documents_location?.length) {
        const files = await Promise.all(
          poDetails?.other_documents_location.map(async (filePath) => {
            const fileName = filePath.split("/").pop();
            const url = await getImageURL({
              bucket_key: `${poNumber}/${fileName}`,
              operation: "download",
            });
            return { name: fileName, url };
          })
        );
        setViewUploadedFiles(files);
      }

      let fileArr = poDetails.other_documents_location.map((item, index) => {
        const extension = item?.split(".").pop();
        let type = "";

        if (extension === "jpg") type = "image/jpg";
        else if (extension === "jpeg") type = "image/jpeg";
        else if (extension === "pdf") type = "application/pdf";

        return {
          name: item?.split("/")[1],
          oldFile: true,
          id: index,
          type,
        };
      });

      setUploadedFile(fileArr);
    }
  };

  fetchData();
}, [poDetails]);

  useEffect(() => {
    if (checkedBox) {
      setCustomerAddress();
    }
  }, [customer]);

  return poDetails && customerList && orderManagementSettings ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0" }}>
        {!editMode && (
          <PageHeader
            onBack={() => window.history.back()}
            title={`PO Details - ${toHandlePOName(
              poDetails?.number?.toUpperCase()
            )}`}
            extra={
              userDetails.roles.order_records.edit_own
                ? [
                    !orderManagementSettings?.fetch_orders_from_erp?.value && (
                      <Button
                        key="2"
                        className="themeBtn noBg"
                        onClick={() => setEditMode(true)}
                        // disabled={uploadedFileErr?.length}
                      >
                        <Iconmoon icon="edit" size={14} color="#ea655b" />
                        Edit
                      </Button>
                    ),
                    <Button key="1" className="themeBtn" onClick={routeChange}>
                      <Iconmoon icon="file-view" size={14} color="#ffffff" />
                      View Orders
                    </Button>,
                  ]
                : [
                    <Button key="1" className="themeBtn" onClick={routeChange}>
                      <Iconmoon icon="file-view" size={14} color="#ffffff" />
                      View Orders
                    </Button>,
                  ]
            }
          ></PageHeader>
        )}
        {editMode && (
          <PageHeader
            onBack={() => window.history.back()}
            title={`PO Details - ${toHandlePOName(
              poDetails?.number?.toUpperCase()
            )}`}
            extra={[
              <Button key="3" className="textTypeBtn" onClick={handleCancel}>
                Cancel changes
              </Button>,
              <Button
                key="2"
                className="themeBtn"
                onClick={saveHandler}
                disabled={uploadedFileErr?.length}
                form="form"
              >
                <Iconmoon icon="correct" size={14} color="#ffffff" />
                Save
              </Button>,
            ]}
          ></PageHeader>
        )}
      </PageTitleComp>
      <DetailFields>
        {/* <HaberForm>
          <StyledTab> */}
        <div className="groupDetailWrap">
          <Form
            id="form"
            form={form}
            name="basic"
            autoComplete="off"
            className="haberLogin"
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
          >
            <HaberForm>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      General details will be used to identify Purchase Order in
                      reports
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>PO Number</label>
                        <p>A unique number to identify the Purchase Order</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="poNumber"
                          rules={[
                            {
                              required: !switchFetchOrdersfromERP,
                              message: "PO number is required",
                            },
                          ]}
                          className=""
                          initialValue={toHandlePOName(
                            poDetails?.number?.toUpperCase()
                          )}
                        >
                          <Input
                            placeholder="Enter PO Number"
                            //onChange={poHandler}
                            disabled={!editMode || !poDetails?.po_editable}
                            style={{ textTransform: "uppercase" }}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>PO Date</label>
                        <p>Date when Purchase Order was received</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <DatePickerY>
                          <Form.Item
                            name="date"
                            initialValue={moment(
                              moment(poDetails?.date).format("DD MM YYYY"),
                              "DD MM YYYY"
                            )}
                          >
                            <DatePicker
                              defaultValue={moment()}
                              format={"DD/MM/YYYY"}
                              disabled={!editMode || !poDetails?.po_editable}
                              onChange={dateHandler}
                              // value={moment()}
                            />
                          </Form.Item>
                        </DatePickerY>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Customer</label>
                        <p>
                          Name of the Customer/Dealer who issued <br />
                          the Purchase Order
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="customer"
                          rules={[
                            {
                              required: !switchFetchOrdersfromERP,
                              message: "Customer is required",
                            },
                          ]}
                          initialValue={poDetails?.customer}
                        >
                          <Select
                            showSearch
                            name="customer"
                            suffixIcon={
                              isCustomerDropdownOpen ? (
                                <DropDownSearchDraw />
                              ) : (
                                <DownArrowDraw />
                              )
                            }
                            onBlur={OntoggleSelect}
                            onFocus={OntoggleSelect}
                            optionFilterProp="children"
                            onChange={customerHandler}
                            placeholder="Select Customer"
                            disabled={!editMode || !poDetails?.po_editable}
                            // filterOption={(input, option) =>
                            //   option.props.children
                            //     .toLowerCase()
                            //     .indexOf(input.toLowerCase()) >= 0 ||
                            //   option.props.value
                            //     .toLowerCase()
                            //     .indexOf(input.toLowerCase()) >= 0
                            // }
                          >
                            {customerList?.map((cust) => (
                              <Option key={cust.code}>
                                {cust.code} - {cust.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Consignee</label>
                        <p>
                          Name of the Consignee responsible for this <br />
                          Purchase Order
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="consignee"
                          rules={[
                            {
                              required: !switchFetchOrdersfromERP,
                              message: "Consignee is required",
                            },
                          ]}
                          initialValue={poDetails?.consignee}
                        >
                          <Select
                            showSearch
                            name="consignee"
                            suffixIcon={
                              isConsigneeDropdownOpen ? (
                                <DropDownSearchDraw />
                              ) : (
                                <DownArrowDraw />
                              )
                            }
                            defaultValue={poDetails?.consignee}
                            onBlur={onToggleSelectForConsginee}
                            onFocus={onToggleSelectForConsginee}
                            optionFilterProp="children"
                            onChange={consigneeHandler}
                            placeholder="Select Consignee"
                            disabled={!editMode || !poDetails?.po_editable}
                          >
                            {customerList?.map((cust) => (
                              <Option key={cust.code}>
                                {cust.code} - {cust.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Delivery Address</h2>
                    <p>
                      The customer/dealer address where order is to be delivered
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Building Number and Street Address</label>
                        <p
                          style={{
                            fontSize: "14px",
                            lineHeight: "20px",
                            fontFamily: "var(--sf-pro-display-m)",
                            color: "var(--black-color)",
                            marginBottom: "5px",
                          }}
                        >
                          The complete postal address for delivery
                        </p>
                        <div className="checklist-address">
                          <Checkbox
                            type="checkbox"
                            value={checkedBox}
                            checked={checkedBox}
                            onChange={onChangeHandlerBox}
                            disabled={!customer || !editMode}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontStyle: "normal",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--para-text)",
                                margin: "0",
                              }}
                            >
                              This address is same as customer delivery address
                            </span>
                          </Checkbox>
                        </div>
                        <div className="checklist-address">
                          <Checkbox
                            type="checkbox"
                            value={deliConsgineeCheckedBox}
                            checked={deliConsgineeCheckedBox}
                            onChange={deliveryAddConsigneeHandler}
                            disabled={!editMode}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontStyle: "normal",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--para-text)",
                                margin: "0",
                              }}
                            >
                              This address is same as consignee delivery address
                            </span>
                          </Checkbox>
                        </div>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        {/* <GlobalSet>
                              <div className="checklist-address">
                                <Checkbox
                                  type="checkbox"
                                  value={checkedBox}
                                  onChange={onChangeHandlerBox}
                                  disabled={!customer}
                                />
                                <p>This address is same as customer address</p>
                              </div>
                            </GlobalSet> */}
                        <DisabledStyles>
                          <Form.Item
                            name="delivery_address_line_1"
                            rules={[
                              {
                                required: !switchFetchOrdersfromERP,
                                message: "This field is required",
                              },
                            ]}
                            className=""
                            initialValue={poDetails?.delivery_address_line_1}
                          >
                            <Input
                              disabled={
                                checkedBox ||
                                deliConsgineeCheckedBox ||
                                poFromOrders?.state?.cancelChangesDisable ||
                                !editMode
                              }
                              type="text"
                              className="disabled-check"
                              placeholder="First Line of address"
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <div className="boxFormType">
                        <DisabledStyles>
                          <Form.Item
                            name="delivery_address_line_2"
                            rules={[{}]}
                            className=""
                            initialValue={poDetails?.delivery_address_line_2}
                          >
                            <Input
                              disabled={
                                checkedBox ||
                                deliConsgineeCheckedBox ||
                                poFromOrders?.state?.cancelChangesDisable ||
                                !editMode
                              }
                              className="disabled-check"
                              placeholder="Second Line of address"
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <Col span={12} className="d-flex">
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="country"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={poDetails?.delivery_country}
                              className=""
                            >
                              <Select
                                className="disabled-check"
                                disabled={
                                  checkedBox ||
                                  deliConsgineeCheckedBox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                suffixIcon={
                                  isCountryDropdownOpen ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                onChange={handleProvinceChange}
                                onBlur={OnCountryToggleSelect}
                                onFocus={OnCountryToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                defaultValue={poDetails.delivery_country}
                                placeholder="Select Country"
                              >
                                {Country.getAllCountries()?.map((province) => (
                                  <Option key={province?.isoCode}>
                                    {province?.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="state"
                              className=""
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={poDetails?.delivery_state}
                            >
                              <Select
                                disabled={
                                  checkedBox ||
                                  deliConsgineeCheckedBox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                suffixIcon={
                                  isStateDropdownOpen ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                onBlur={OnStateToggleSelect}
                                onFocus={OnStateToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                placeholder="Select State"
                                defaultValue={poDetails?.delivery_state}
                              >
                                {cities?.map((city) => (
                                  <Option key={city?.name}>{city?.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                      <Col span={12} className="d-flex">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <DisabledStyles>
                            <Form.Item
                              name="City"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={poDetails?.delivery_city}
                              className=""
                            >
                              <Input
                                placeholder="City"
                                disabled={
                                  checkedBox ||
                                  deliConsgineeCheckedBox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                className="disabled-check"
                                style={{ textTransform: "capitalize" }}
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="pincode"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                                { min: 6, message: "Minimum length: 6" },
                                { max: 6, message: "Maximum length: 6" },
                                {
                                  pattern: new RegExp(/^[0-9]+$/),
                                  message: "Only Numeric value is possible",
                                },
                              ]}
                              initialValue={poDetails?.delivery_pincode}
                              className=""
                            >
                              <Input
                                disabled={
                                  checkedBox ||
                                  deliConsgineeCheckedBox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                className="disabled-check"
                                placeholder="ZIP code"
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Shipping Address</h2>
                    <p>
                      The customer/dealer address where order is to be shipped
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Building Number and Street Address</label>
                        <p
                          style={{
                            fontSize: "14px",
                            lineHeight: "20px",
                            fontFamily: "var(--sf-pro-display-m)",
                            color: "var(--black-color)",
                            marginBottom: "5px",
                          }}
                        >
                          The complete postal address for shipping
                        </p>
                        <div className="checklist-address">
                          <Checkbox
                            type="checkbox"
                            value={shippedCustAddCheckbox}
                            checked={shippedCustAddCheckbox}
                            onChange={shippedAddCustHandler}
                            disabled={!customer || !editMode}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontStyle: "normal",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--para-text)",
                                margin: "0",
                              }}
                            >
                              This address is same as customer delivery address
                            </span>
                          </Checkbox>
                        </div>
                        <div className="checklist-address">
                          <Checkbox
                            type="checkbox"
                            value={shippedConsigneeAddCheckbox}
                            checked={shippedConsigneeAddCheckbox}
                            onChange={shippedAddConsigneeHandler}
                            disabled={!editMode}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontStyle: "normal",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--para-text)",
                                margin: "0",
                              }}
                            >
                              This address is same as consignee delivery address
                            </span>
                          </Checkbox>
                        </div>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <DisabledStyles>
                          <Form.Item
                            name="shipping_address_line_1"
                            rules={[
                              {
                                required: !switchFetchOrdersfromERP,
                                message: "This field is required",
                              },
                            ]}
                            className=""
                            initialValue={poDetails?.shipping_address_line_1}
                          >
                            <Input
                              disabled={
                                shippedCustAddCheckbox ||
                                shippedConsigneeAddCheckbox ||
                                poFromOrders?.state?.cancelChangesDisable ||
                                !editMode
                              }
                              type="text"
                              className="disabled-check"
                              placeholder="First Line of address"
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <div className="boxFormType">
                        <DisabledStyles>
                          <Form.Item
                            name="shipping_address_line_2"
                            rules={[{}]}
                            className=""
                            initialValue={poDetails?.shipping_address_line_2}
                          >
                            <Input
                              disabled={
                                shippedCustAddCheckbox ||
                                shippedConsigneeAddCheckbox ||
                                poFromOrders?.state?.cancelChangesDisable ||
                                !editMode
                              }
                              className="disabled-check"
                              placeholder="Second Line of address"
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <Col span={12} className="d-flex">
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="shipping_country"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={poDetails?.shipping_country}
                              className=""
                            >
                              <Select
                                className="disabled-check"
                                disabled={
                                  shippedCustAddCheckbox ||
                                  shippedConsigneeAddCheckbox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                defaultValue={poDetails?.shipping_country}
                                suffixIcon={
                                  isShippingCountryDropdownOpen ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                onChange={handleProvinceChangeForShipping}
                                onBlur={OnShippingCountryToggleSelect}
                                onFocus={OnShippingCountryToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                placeholder="Select Country"
                              >
                                {Country.getAllCountries()?.map((province) => (
                                  <Option key={province?.isoCode}>
                                    {province?.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="shipping_state"
                              className=""
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={poDetails?.shipping_state}
                            >
                              <Select
                                disabled={
                                  shippedCustAddCheckbox ||
                                  shippedConsigneeAddCheckbox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                defaultValue={poDetails?.shipping_state}
                                suffixIcon={
                                  isShippingStateDropdownOpen ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                onBlur={OnShippingStateToggleSelect}
                                onFocus={OnShippingStateToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                placeholder="Select State"
                              >
                                {shippingCities?.map((city) => (
                                  <Option key={city?.name}>{city?.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                      <Col span={12} className="d-flex">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <DisabledStyles>
                            <Form.Item
                              name="shipping_city"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              className=""
                              initialValue={poDetails?.shipping_city}
                            >
                              <Input
                                placeholder="City"
                                disabled={
                                  shippedCustAddCheckbox ||
                                  shippedConsigneeAddCheckbox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                className="disabled-check"
                                style={{ textTransform: "capitalize" }}
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="shipping_pincode"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                                { min: 6, message: "Minimum length: 6" },
                                { max: 6, message: "Maximum length: 6" },
                                {
                                  pattern: new RegExp(/^[0-9]+$/),
                                  message: "Only Numeric value is possible",
                                },
                              ]}
                              initialValue={poDetails?.shipping_pincode}
                              className=""
                            >
                              <Input
                                disabled={
                                  shippedCustAddCheckbox ||
                                  shippedConsigneeAddCheckbox ||
                                  poFromOrders?.state?.cancelChangesDisable
                                }
                                className="disabled-check"
                                placeholder="ZIP code"
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Billing Address</h2>
                    <p>
                      The customer/dealer address where order is to be billed
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Building Number and Street Address</label>
                        <p
                          style={{
                            fontSize: "14px",
                            lineHeight: "20px",
                            fontFamily: "var(--sf-pro-display-m)",
                            color: "var(--black-color)",
                            marginBottom: "5px",
                          }}
                        >
                          The complete postal address for billing
                        </p>
                        <div className="checklist-address">
                          <Checkbox
                            type="checkbox"
                            value={billingCustAddCheckbox}
                            checked={billingCustAddCheckbox}
                            onChange={billingAddCustHandler}
                            disabled={!customer || !editMode}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontStyle: "normal",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--para-text)",
                                margin: "0",
                              }}
                            >
                              This address is same as customer office <br />
                              address
                            </span>
                          </Checkbox>
                        </div>
                        <div className="checklist-address">
                          <Checkbox
                            type="checkbox"
                            value={billingConsigneeAddCheckbox}
                            checked={billingConsigneeAddCheckbox}
                            onChange={billingAddConsigneeHandler}
                            disabled={!editMode}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontStyle: "normal",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--para-text)",
                                margin: "0",
                              }}
                            >
                              This address is same as consignee office <br />
                              address
                            </span>
                          </Checkbox>
                        </div>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <DisabledStyles>
                          <Form.Item
                            name="billing_address_line_1"
                            rules={[
                              {
                                required: !switchFetchOrdersfromERP,
                                message: "This field is required",
                              },
                            ]}
                            initialValue={poDetails?.billing_address_line_1}
                            className=""
                          >
                            <Input
                              disabled={
                                billingCustAddCheckbox ||
                                billingConsigneeAddCheckbox ||
                                poFromOrders?.state?.cancelChangesDisable ||
                                !editMode
                              }
                              type="text"
                              className="disabled-check"
                              placeholder="First Line of address"
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <div className="boxFormType">
                        <DisabledStyles>
                          <Form.Item
                            name="billing_address_line_2"
                            rules={[{}]}
                            className=""
                            initialValue={poDetails?.billing_address_line_2}
                          >
                            <Input
                              disabled={
                                billingCustAddCheckbox ||
                                billingConsigneeAddCheckbox ||
                                poFromOrders?.state?.cancelChangesDisable ||
                                !editMode
                              }
                              className="disabled-check"
                              placeholder="Second Line of address"
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <Col span={12} className="d-flex">
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="billing_country"
                              initialValue={poDetails?.billing_country}
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              className=""
                            >
                              <Select
                                className="disabled-check"
                                disabled={
                                  billingCustAddCheckbox ||
                                  billingConsigneeAddCheckbox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                defaultValue={poDetails?.billing_country}
                                suffixIcon={
                                  isBillingCountryDropdownOpen ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                onChange={handleProvinceChangeForBilling}
                                onBlur={OnBillingCountryToggleSelect}
                                onFocus={OnBillingCountryToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                placeholder="Select Country"
                              >
                                {Country.getAllCountries()?.map((province) => (
                                  <Option key={province?.isoCode}>
                                    {province?.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="billing_state"
                              className=""
                              initialValue={poDetails?.billing_state}
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              <Select
                                disabled={
                                  billingCustAddCheckbox ||
                                  billingConsigneeAddCheckbox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                defaultValue={poDetails?.billing_state}
                                suffixIcon={
                                  isBillingStateDropdownOpen ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                onBlur={OnBillingStateToggleSelect}
                                onFocus={OnBillingStateToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                placeholder="Select State"
                              >
                                {billingCities?.map((city) => (
                                  <Option key={city?.name}>{city?.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                      <Col span={12} className="d-flex">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <DisabledStyles>
                            <Form.Item
                              name="billing_city"
                              initialValue={poDetails?.billing_city}
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              className=""
                            >
                              <Input
                                placeholder="City"
                                disabled={
                                  billingCustAddCheckbox ||
                                  billingConsigneeAddCheckbox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                className="disabled-check"
                                style={{ textTransform: "capitalize" }}
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="billing_pincode"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                                { min: 6, message: "Minimum length: 6" },
                                { max: 6, message: "Maximum length: 6" },
                                {
                                  pattern: new RegExp(/^[0-9]+$/),
                                  message: "Only Numeric value is possible",
                                },
                              ]}
                              className=""
                              initialValue={poDetails?.billing_pincode}
                            >
                              <Input
                                disabled={
                                  billingCustAddCheckbox ||
                                  billingConsigneeAddCheckbox ||
                                  poFromOrders?.state?.cancelChangesDisable ||
                                  !editMode
                                }
                                className="disabled-check"
                                placeholder="ZIP code"
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </HaberForm>
            <Row gutter={[16, 16]} className="groupForm lastGroup">
              <Col span={8}>
                <GroupTitle>
                  <h2>Other Information</h2>
                  <p>All other information related to this PO</p>
                </GroupTitle>
              </Col>
              <Col span={16}>
                <Row className="centerAlign">
                  <Col span={12}>
                    <div className="boxFieldTitle">
                      <label>Documents</label>
                      <p
                        style={{
                          fontSize: "14px",
                          lineHeight: "20px",
                          fontFamily: "var(--sf-pro-display-m)",
                          color: "var(--black-color)",
                          marginBottom: "5px",
                          width: "91%",
                        }}
                      >
                        Scanned copies, PDF and other documents related to the
                        POP
                      </p>
                    </div>
                  </Col>
                  {editMode ? (
                    <Col span={12} className="blockBreak">
                      {uploadedFileErr?.length
                        ? uploadedFileErr?.map((item, index) => {
                            return item.err ? (
                              <>
                                {index > 0 ? <br></br> : ""}
                                <span
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-17px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Invalid file: {item.name}
                                </span>
                              </>
                            ) : (
                              ""
                            );
                          })
                        : ""}
                      {uploadedFileErr?.length ? (
                        <>
                          <br></br>
                          <span
                            className="errorText"
                            style={{
                              color: "#ea4e2c",
                              marginTop: "-17px",
                              marginBottom: "5px",
                            }}
                          >
                            Supported file formats : JPG, JPEG or PDF; Max
                            allowed size : 1 mb
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                      <div
                        className="boxFormType csv-file"
                        style={{ marginBottom: "0" }}
                      >
                        <Dragger
                          {...fileUploadData}
                          style={{ border: "1px dashed #d9d9d9" }}
                        >
                          <p
                            className="ant-upload-drag-icon"
                            style={{ marginTop: "11px" }}
                          >
                            <Iconmoon
                              icon="upload-image"
                              size={18}
                              color="#A19F9D"
                            />
                          </p>
                          <p className="ant-upload-text">
                            <span>Click to add</span> or drag and drop
                          </p>
                          <p
                            className="ant-upload-hint"
                            style={{ marginBottom: "11px" }}
                          >
                            JPG, JPEG or PDF (max. 1 MB)
                          </p>
                        </Dragger>
                      </div>
                    </Col>
                  ) : (
                    <Col span={12} className="blockBreak">
                      {viewUploadedFiles?.length
                        ? viewUploadedFiles.map((ele, index) => (
                            <div key={index} className="boxFieldTitle">
                              <a
                                href={ele.url || ""}
                                download={ele.name}
                                style={{ color: "#EA655B" }}
                              >
                                {ele.name}
                              </a>
                            </div>
                          ))
                        : "no files"}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
        {/* </StyledTab> */}
        {/* Cancel changes modal */}
        <ModalPopup visible={isVisibleCancelModal}>
          <div className="Popup-img">
            <img src={warning} alt="Warning" />
          </div>
          <div className="Popup-content">
            <span>Are you sure?</span>
            <p>
              You have pending changes on this page, are you sure you want to
              leave?
            </p>
          </div>
          <div className="ant-modal-footer-section">
            <Button
              key="back"
              className="themeBtn-plane"
              onClick={() => modalCancelClose()}
            >
              <div className="plusPopUpBorder">
                <Iconmoon
                  icon="plus-sign"
                  size={9}
                  color="#EA655B"
                  className="ant-ico-sec"
                />
              </div>
              Cancel
            </Button>

            <Button
              key="submit"
              className="themeBtn"
              onClick={() => modalCancelConfirm()}
            >
              <Iconmoon icon="tick-mark" size={14} color="#ffff" />
              Confirm
            </Button>
          </div>
        </ModalPopup>
        {/* </HaberForm> */}
      </DetailFields>

      {success && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg="PO is updated Successfully"
        />
      )}
      {error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg="Error in Saving"
        />
      )}
    </RightLayoutContainer>
  ) : (
    <></>
  );
};

export default PoDetailsData;
